
export enum AssetGearboxType {
  Auto= 'Auto',
  SemiAuto= 'SemiAuto',
  Manual= 'Manual',

}